import {configureStore} from '@reduxjs/toolkit';
import {banksReducer} from './slices/banks.slice';
import {employeesReducer} from './slices/employees.slice';
import {proformasReducer} from './slices/proformas.slice';
import {labourPaymentsReducer} from './slices/labour-payments.slice';

export const store = configureStore({
    reducer: {
        banks: banksReducer,
        employees: employeesReducer,
        proformas: proformasReducer,
        labourPayments: labourPaymentsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
